import List, { ListDataItem } from "@/components/visualizations/List/List";
import { useDateRange } from "@/pages/dashboard/hooks/useDateRange";
import { ProductBy, useProductImpactCategories } from "@/pages/dashboard/hooks/useProductImpact";
import { useEffect, useState } from "react";
import { ImpactMetric } from "../../../utils/types";

const step = 5;

export default function ProductImpactTopContributorsPerCategory({
  metric,
  by,
}: {
  metric: ImpactMetric;
  by: ProductBy;
}) {
  const [limit, setLimit] = useState(step);
  const { startDate, endDate } = useDateRange();

  useEffect(() => {
    setLimit(step);
  }, [startDate, endDate, by]);

  const { data, isLoading, isFetching } = useProductImpactCategories({
    pagination: {
      page: 1,
      pageSize: limit + step,
    },
    sort: {
      key: "product_" + metric.key,
      order: "descend",
    },
    by,
    metric: metric.key,
  });

  const numMore = Math.min((data?.data.length || 0) - limit);

  const listData = data
    ? data?.data.slice(0, limit).map((row, index) => {
        return {
          label: row.category || "No category",
          id: index,
          value: row.impact.product[metric.key],
        };
      })
    : [];

  interface TopContributorsList extends ListDataItem {
    id: number;
  }

  return (
    <List<TopContributorsList>
      loading={isLoading || isFetching}
      data={{
        list: listData,
        total: data?.total_impact.product[metric.key],
      }}
      loadMore={{
        show: numMore > 0,
        numberOfMore: numMore,
        fn: () => setLimit(limit + step),
      }}
      format={metric.formatter}
    />
  );
}
